export const getCustomizeFileName = (fileName) => {
    // Get the current timestamp
    const timestamp = new Date().toISOString().replace(/[:.-]/g, '_');

    // Use regex to split the filename into base and extension
    const match = fileName.match(/^(.*?)(\.[^.]*)?$/);
    let baseName = match[1] || '';
    const extension = match[2] || '';

    // Sanitize the base file name using regex
    baseName = baseName
        .trim()
        .replace(/\s+/g, '_') // Replace spaces with underscores
        .replace(/[^a-zA-Z0-9_-]+/g, '_') // Replace other unwanted characters with underscores
        .replace(/_+/g, '_'); // Collapse multiple underscores

    return {
        fileBaseName: baseName,
        fileExtension: match[2] || '',
        fileTimestamp: timestamp
    }
};